exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-container[data-v-1a50feac]{border:1px solid;border-color:#ccc!important;border-radius:.5rem;overflow:hidden}.border-red[data-v-1a50feac]{border-color:red!important}.border-section[data-v-1a50feac]{border:1px solid;border-color:#ccc;border-radius:.5rem}.datepicker-container[data-v-1a50feac]{padding:5px}.colab-container[data-v-1a50feac]{min-height:82px}", ""]);

// exports
